import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction, loadDataErrorAction } from 'modules/app/actions';
import { fetchVisitAndUnitsSuccess, fetchVisitAndUnitsError } from '../actions';
import { VISIT_AND_UNITS } from '../constants/actionTypes';
import { getVisit, getVisitUnits } from '../repository';


function *_fetchVisitAndUnitsAsync(action) {
    const {vtrac} = action;

    yield put(loadDataAction('visit'));
    try {
        let [visit, units] = yield [
            call(getVisit(vtrac)),
            call(getVisitUnits(vtrac))
        ];
        visit.units = units;
        yield put(fetchVisitAndUnitsSuccess(visit));
        yield put(loadDataSuccessAction('visit'));
    } catch (error) {
        yield put(fetchVisitAndUnitsError(error));
        yield put(loadDataErrorAction('visit', {response: error.response}, action));
    }
}

export function *fetchVisitAndUnitsAsync() {
    yield takeEvery(VISIT_AND_UNITS.REQUEST, _fetchVisitAndUnitsAsync);
}
